function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M28.781 4.694c4.766 5.579 1.82 13.643-12.148 25.08a1 1 0 0 1-1.267 0C1.47 18.394-1.419 10.385 3.204 4.712 6.439.74 12.294.929 16 4.636c3.705-3.705 9.408-3.89 12.781.058z"
});

var SvgFavoriteFill = function SvgFavoriteFill(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "121db9450b36c1d47e06e774acda24c9.svg";
export { SvgFavoriteFill as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/favorite-fill.svg
// module id = null
// module chunks = 